// Phase E Cycle 5 — values sourced from the canonical BE enum.
import { WayOfCommunication } from 'types/api/treatmentForm';

export const WayOfCommunicationValues = {
  email: WayOfCommunication.Email,
  phoneCall: WayOfCommunication.Phone,
  whatsapp: WayOfCommunication.Whatsapp,
  noPreferences: WayOfCommunication.None
} as const satisfies Record<string, WayOfCommunication>;

export const WAY_OF_COMMUNICATION: Array<{
  value: WayOfCommunication;
  label: string;
}> = [
  { value: WayOfCommunication.Email, label: 'Email' },
  { value: WayOfCommunication.Phone, label: 'Phone Call' },
  { value: WayOfCommunication.Whatsapp, label: 'Whatsapp' },
  { value: WayOfCommunication.None, label: 'No Preferences' }
];
